<template>
  <li class="row-content d-flex">
    <template v-if="matches && matches.length > 0">
      <span
        class="t-600"
        :class="{
          'mr-4': $slots && $slots.post,
          'bd-radius t-overflow bg-highlight d-inline-block': view === 'list' || view === 'block'
        }"
      >
        <span
          :class="{
            'bg-highlight-dark px-2 py-1 t-xs': view === 'list' || view === 'block'
          }">Match in</span>
        <span
          v-if="view === 'block'"
          class="t-sm px-2"
          v-html="matchIconArray.join(`<span class='mr-2'></span>`)"
        />
        <span
          v-else-if="view === 'list'"
          class="t-sm px-2"
          v-html="matchTextArray.join(', ')"
        />
        <span
          v-else-if="view === 'popover'"
          class="ml-1"
          v-html="matchIconTextArray.join(`, `)"
        />
      </span>
    </template>
    <slot name="post" />
  </li>
</template>

<script>
import { ICONS } from '@/assets/js/_data'

export default {
  name: 'resultMatches',
  props: {
    matches: {
      type: Array,
      required: true
    },
    view: {
      type: String,
      default: 'block'
    }
  },
  computed: {
    matchTextArray () {
      const arr = []
      this.matches.forEach(match => {
        if (!match.show_count) arr.push(this.$options.filters.titleize(match.name))
        else arr.push(`${match.count} ${this.$options.filters.titleize(this.$options.filters.pluralize(match.name, match.count))}`)
      })
      return arr
    },
    matchIconTextArray () {
      const arr = []
      this.matches.forEach(match => {
        const icon = ICONS[match.name]
        if (icon) {
          if (!match.show_count) {
            arr.push(`<mark>${this.$options.filters.titleize(match.name)}</mark> <i class="${icon} t-white"></i>`)
          } else {
            arr.push(`<mark>${match.count} ${this.$options.filters.titleize(this.$options.filters.pluralize(match.name, match.count))}</mark> <i class="${icon} t-white"></i>`)
          }
        } else {
          if (!match.show_count) arr.push(`<mark>${this.$options.filters.titleize(match.name)}</mark>`)
          else arr.push(`<mark>${match.count} ${this.$options.filters.titleize(this.$options.filters.pluralize(match.name, match.count))}</mark>`)
        }
      })
      return arr
    },
    matchIconArray () {
      const arr = []
      this.matches.forEach(match => {
        const icon = ICONS[match.name]
        if (icon) {
          if (!match.show_count) {
            arr.push(` <i class="${icon} t-grey"></i> `)
          } else {
            arr.push(`${match.count} <i class="${icon} t-grey"></i> `)
          }
        } else {
          if (!match.show_count) {
            arr.push(this.$options.filters.titleize(match.name))
          } else {
            arr.push(`${match.count} ${this.$options.filters.titleize(this.$options.filters.pluralize(match.name, match.count))}`)
          }
        }
      })
      return arr
    }
  }
}
</script>
